<script>
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ButtonIcon from "@/components/molecules/button-icon";

export default {
  name: "AchatsExpress",
  components: { List, ListItem, ButtonIcon },
  methods: {
    redirect(slug) {
      navigateToInternal(slug);
    }
  }
};
</script>

<template>
  <List class="c-header-achats-express">
    <ListItem class="c-header-achats-express__item">
      <ButtonIcon
        icon-name="mes-listes"
        size="md"
        class="c-header-achats-express__button"
        @click="redirect('/mon-compte/mes-listes-de-courses')"
      >
        <span class="u-font-12">Mes listes</span>
      </ButtonIcon>
    </ListItem>
    <ListItem class="c-header-achats-express__item">
      <ButtonIcon
        icon-name="heart"
        size="md"
        class="c-header-achats-express__button"
        @click="redirect('/mon-compte/mes-produits-habituels')"
      >
        <span class="u-font-12">Mes produits habituels</span>
      </ButtonIcon>
    </ListItem>

    <ListItem class="c-header-achats-express__item">
      <ButtonIcon
        icon-name="timer"
        size="md"
        class="c-header-achats-express__button"
        @click="redirect('/mon-compte/mes-commandes')"
      >
        <span class="u-font-12">Mes dernières commandes</span>
      </ButtonIcon>
    </ListItem>
    <!-- <ListItem class="c-header-achats-express__item">
      <ButtonIcon
        icon-name="one-click"
        size="md"
        class="c-header-achats-express__button"
      >
        <span class="u-font-12">Panier en un clic</span>
      </ButtonIcon>
    </ListItem> -->
  </List>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-achats-express.scss";
</style>
